import React from 'react';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';
import '../index.css';

export function NotificationCount({row, columnIndex}) { 
    
    const cellData = (cell, columnName, cssClassName) => {
        return (<div className={cssClassName ? "table-body-cell "+ cssClassName : "table-body-cell"}>{cell[columnName]}</div>);
    }

    return (
        row.notificationCount > 0 && row.notificationDetails && row.notificationDetails.length > 0 ?
        <div>
            <OverlayTrigger
                trigger="click"
                rootClose
                key={`count-dtl-key-`+columnIndex}
                placement={"bottom"}
                overlay={
                <Popover id={`count-dtl-`+columnIndex} style={{maxWidth: "25vw"}} > 
                    <Popover.Content>
                        <>
                            <input type="text" className="hidden-box" size={0} autoFocus={true} />
                            <div id="resp-table" className="scroller" tabIndex="0">
                                <div id="resp-table-body">
                                    {
                                        row.notificationDetails.map((d, index)=> {
                                            return (
                                                <div key={"dtl-row-"+index} className="resp-table-row">
                                                    {cellData(d, "emailSendingType")}
                                                    {cellData(d, "receiverEmailId", "email-adjust")}
                                                    {cellData(d, "sentNotificationDate")}
                                                    {cellData(d, "sentNotificationTime")}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </>
                    </Popover.Content>
                </Popover>
                }
            ><Button id={`btn-cnt-`+columnIndex} variant="link"><span className="count-value">{row.notificationCount}</span></Button></OverlayTrigger>
        </div>
        : <span className="count-value">{row.notificationCount}</span>
    )
}